import React from "react";
import { getBackendBaseURL } from "../axios";
import { useSelector } from "react-redux";
import { AddFlex, FullPageParent, Icon } from "../reusableStyles";
import {
  BulletList,
  Button,
  Header,
  InstallationSection,
  ListItem,
  OverviewSection,
  PageContainer,
  Paragraph,
  SectionTitle,
  Title,
} from "./GoogleCalendarIntegrationPage";
import zoomLogo from "../ImageAssets/zoom.png";
import useIntegrationHooks from "../CustomHooks/useIntegrationHooks";
import Loading from "../Loading";

function ZoomIntegrationPage() {
  const userState = useSelector((state) => state.user);

  const getSuccesMsg = () => {
    return "Your Zoom Account is integrated Successfully";
  };

  const getFailureMsg = () => {
    return "There is some error in connecting to Zoom Account";
  };

  const { apiLoading, isIntegrationActivated } = useIntegrationHooks(
    "zoom",
    getSuccesMsg,
    getFailureMsg
  );

  return apiLoading ? (
    <FullPageParent>
      <Loading />
    </FullPageParent>
  ) : (
    <AddFlex justify="flex-start">
      <PageContainer>
        <Header alignItems="center" gap="20px">
          <Icon src={zoomLogo} style={{ width: "42px", height: "42px" }} />
          <Title>Zoom</Title>
          <Button
            onClick={() => {
              if (isIntegrationActivated()) return;
              const zoom_auth_uri = `${getBackendBaseURL()}integrations/zoomAuth?username=${
                userState.apiUserData.userName
              }`;
              window.location.href = zoom_auth_uri;
            }}
          >
            {isIntegrationActivated() ? "Connected" : "Connect Now"}
          </Button>
        </Header>
        <OverviewSection>
          {/* <SectionTitle>Overview</SectionTitle> */}
          {/* <div>
            Video conferencing software is the cornerstone of any successful and
            productive team. Video conferencing tools, like Zoom, allow
            individuals to meet and work together productively "face-to-face"
            when meeting in-person isn't possible. This makes meeting remotely
            much more human, which essential in order to help users feel and
            stay connected.
          </div> */}
          <Paragraph
            style={{
              fontSize: "20px",
            }}
          >
            After integrating Zoom, you can:
          </Paragraph>
          <BulletList>
            <ListItem>
              Host interactive online classes with your audience right from your
              Growezy portal.
            </ListItem>
            <ListItem>
              Get auto-generated zoom meeting links in 1 or 2 clicks for all
              your online offerings.
            </ListItem>
            <ListItem>
              Access the meet links from the dashboard once you receive the
              bookings.
            </ListItem>
            <ListItem>
              Personalized meeting links will be shared with your customers
              after booking.
            </ListItem>
            <ListItem>Makes it easy to track attendance.</ListItem>
          </BulletList>
        </OverviewSection>
        <InstallationSection>
          {/* <SectionTitle>Installation</SectionTitle> */}
          <Paragraph>How do you integrate Zoom?</Paragraph>
          <BulletList>
            <ListItem>
              Click on the Connect Zoom at the top right. You'll be directed to
              the Zoom Marketplace for authorisation.
            </ListItem>
            <ListItem>Click on the button: 'Sign in to add'</ListItem>
            <ListItem>
              Sign in with the account you want to integrate zoom for.
            </ListItem>
            <ListItem>
              You'll be asked for access. Click on Select the checkbox asking
              for shared access permissions
            </ListItem>
            <ListItem>Click on 'Allow'</ListItem>
            <ListItem>
              Once done, zoom will be integrated with your account.
            </ListItem>
          </BulletList>
        </InstallationSection>
      </PageContainer>
    </AddFlex>
    // <IntegrationContainer>
    //   <Instructions>
    //     <InstructionItem>1. Sign in to your Zoom account.</InstructionItem>
    //     <InstructionItem>
    //       2. Navigate to the Zoom App Marketplace.
    //     </InstructionItem>
    //     <InstructionItem>
    //       3. Create a new app and select JWT as the app type.
    //     </InstructionItem>
    //     <InstructionItem>
    //       4. Fill out the necessary information and generate your JWT token.
    //     </InstructionItem>
    //     <InstructionItem>
    //       5. Use the JWT token in your application to integrate Zoom
    //       functionalities.
    //     </InstructionItem>
    //   </Instructions>
    //   <ConnectButton
    //     onClick={() => {
    //       if (isZoomIntegrated()) return;
    //       const zoom_auth_uri = `${getBackendBaseURL()}integrations/zoomAuth?username=${
    //         userState.apiUserData.userName
    //       }`;
    //       window.location.href = zoom_auth_uri;
    //     }}
    //   >
    //     {isZoomIntegrated() ? "Connected" : "Connect"}
    //   </ConnectButton>
    // </IntegrationContainer>
  );
}

export default ZoomIntegrationPage;
